import {createMuiTheme} from '@material-ui/core/styles';

export const theme = createMuiTheme({
    palette: {
        primary: {
            light: '#22A2F3', // 基本の色よりも明るい色
            main: '#22A2F3', // 基本の色
            dark: '#22A2F3', // 基本の色よりも暗い色
            contrastText: '#fff', // テキストの色
        },
        default: {
            light: '#9A9A9A', // 基本の色よりも明るい色
            main: '#9A9A9A', // 基本の色
            dark: '#9A9A9A', // 基本の色よりも暗い色
            contrastText: '#fff', // テキストの色
        },
        secondary: {
            light: '#545454', // 基本の色よりも明るい色
            main: '#545454', // 基本の色
            dark: '#545454', // 基本の色よりも暗い色
            contrastText: '#fff', // テキストの色
        }
    },
});
